import axios from "axios";
import router from "../router/index";
import { MessageBox } from "element-ui";

let TOKEN_KEY = "_yunyi_portal_token";

axios.defaults.withCredentials = true;
const service = axios.create({
  timeout: 100000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});
service.interceptors.request.use(
  (config) => {
    config.url = "/portal-api" + config.url;
    if (!config.noToken) {
      config.headers.Authorization =
        "Bearer " + localStorage.getItem(TOKEN_KEY);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const { data, status } = response;
    // 状态码
    const code = data?.code || status;
    // 获取错误信息
    const msg = data?.msg || `系统未知错误，请反馈给管理员`;

    if (code === 401) {
      // 登录超时, 跳转登录页面
      localStorage.clear();
      MessageBox.confirm("登录信息失效，请重新登录", "提示", {
        confirmButtonText: "去登录",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          router.push("/login");
        })
        .catch(() => {
          window.location.reload();
        });
      return Promise.reject(new Error("Unauthorized"));
    }
    if (code !== 200) {
      return Promise.reject(new Error(msg));
    }
    return Promise.resolve(data ?? response);
  },
  (error) => {
    if (error?.response?.status === 401) {
      // 回到登陆页面
      localStorage.clear();
      router.replace({
        path: "/login",
      });
    }
    return Promise.reject(error);
  },
);

export default service;
